import React from 'react'
import styled from 'styled-components'

import ErrorText from './ErrorText'

const StyledTextHeading = styled.p`
	font-weight: 600;
	margin: 0.5em auto;
	font-size: 115%;
	color: ${({ theme, headingColor = theme.darkGrey }) => headingColor};
`

const StyledTextBox = styled.textarea`
	min-width: 5em;
	width: ${({ width }) => width};
	height: ${({ height }) => height};
	color: ${({ theme, textColor = theme.darkGrey }) => textColor};
	outline: none;
	border: 1px solid ${({ disabled }) => (disabled ? '#dedede' : '#707070')};
	border-radius: 20px;
	font-size: 115%;
	padding: 0.5em;
`

const TextBox = ({
	width = '100%',
	height = '5em',
	disabled,
	placeholder,
	heading,
	onChange,
	error,
	...props
}) => (
	<div>
		<StyledTextHeading {...props}>{heading}</StyledTextHeading>
		<StyledTextBox
			{...props}
			disabled={disabled}
			width={width}
			height={height}
			placeholder={placeholder}
			onChange={evt => onChange(evt)}
		/>
		{error && <ErrorText error={error} />}
	</div>
)

export default TextBox



// WEBPACK FOOTER //
// ./src/artzu-ui/src/TextBox/index.js